module.exports = __webpack_public_path__ + "GW.svg?6a8fd12dcd97afbe143631df11efa7d2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/GW.svg
// module id = 62
// module chunks = 0